import BasePerimeter from '@/kindergarten/perimeters/BasePerimiter';
import BaseRolePerimeter from '@/kindergarten/perimeters/BaseRolePerimeter';
import BaseRoleNotAgentPerimeter from '@/kindergarten/perimeters/BaseRoleNotAgentPerimeter';
import BaseOrAgentRolePerimeter from '@/kindergarten/perimeters/BaseOrAgentRolePerimeter';
import ProjectPerimeter from '@/kindergarten/perimeters/ProjectPerimeter';
import SlsOpsPerimeter from '@/kindergarten/perimeters/SlsOpsPerimeter';
import SlsPerimeter from '@/kindergarten/perimeters/SlsPerimeter';
import TradingPerimeter from '@/kindergarten/perimeters/TradingPerimeter';
import PdmPerimeter from '@/kindergarten/perimeters/PdmPerimeter';
import InternalPerimeter from '@/kindergarten/perimeters/InternalPerimeter';
import GuestPerimeter from '@/kindergarten/perimeters/GuestPerimeter';
import AuthPerimeter from '@/kindergarten/perimeters/AuthPerimeter';
import AdminPerimeter from '@/kindergarten/perimeters/AdminPerimeter';
import ManagementPerimeter from '@/kindergarten/perimeters/ManagementPerimeter';
import MyHpPerimeter from '@/kindergarten/perimeters/MyHpPerimeter';
import MyHpNoFinPerimeter from '@/kindergarten/perimeters/MyHpNoFinPerimeter';
import MyHpBasePerimeter from '@/kindergarten/perimeters/MyHpBasePerimeter';
import AdminHRCPerimeter from '@/kindergarten/perimeters/AdminHRCPerimeter';
import AdminHRVPerimeter from '@/kindergarten/perimeters/AdminHRVPerimeter';
import AdminMDTPerimeter from '@/kindergarten/perimeters/AdminMDTPerimeter';

export const perimeters = {
  BasePerimeter,
  GuestPerimeter,
  AuthPerimeter,
  AdminPerimeter,
  BaseRolePerimeter,
  BaseOrAgentRolePerimeter,
  BaseRoleNotAgentPerimeter,
  ProjectPerimeter,
  SlsOpsPerimeter,
  SlsPerimeter,
  TradingPerimeter,
  InternalPerimeter,
  PdmPerimeter,
  ManagementPerimeter,
  MyHpPerimeter,
  MyHpNoFinPerimeter,
  MyHpBasePerimeter,
  AdminHRCPerimeter,
  AdminHRVPerimeter,
  AdminMDTPerimeter,
};

export const redirectRoutes = {
  GuestPerimeter: 'home.index',
  AuthPerimeter: 'login.index',
  AdminPerimeter: 'home.index',
  ProjectPerimeter: 'home.index',
  BaseRolePerimeter: 'home.index',
  BaseOrAgentRolePerimeter: 'home.index',
  BaseRoleNotAgentPerimeter: 'home.index',
  SlsOpsPerimeter: 'home.index',
  SlsPerimeter: 'home.index',
  InternalPerimeter: 'home.index',
  PdmPerimeter: 'home.index',
  TradingPerimeter: 'home.index',
  ManagementPerimeter: 'home.index',
  MyHpPerimeter: 'home.index',
  MyHpNoFinPerimeter: 'home.index',
  MyHpBasePerimeter: 'home.index',
  AdminHRCPerimeter: 'home.index',
  AdminHRVPerimeter: 'home.index',
  AdminMDTPerimeter: 'home.index',
};



// WEBPACK FOOTER //
// ./src/kindergarten/perimeters/index.js